import type { HelpTopic } from '../core/index.js'

/** The roster module's help topics (docs/plans/in-app-help-plan.md). */
export const ROSTER_HELP_TOPICS: readonly HelpTopic[] = [
  {
    id: 'roster.dashboard',
    title: 'The facility dashboard',
    seats: ['operator', 'facility_administrator'],
    summary: 'Everything happening at this facility, a tab each: how the roster stands and what the month needs, what is new, every worker’s live score, which shifts need covering, and the partner’s rankings.',
    sections: [
      {
        heading: 'The tabs',
        points: [
          'Overview sums up the roster - its size, the share in Gold, the average score, this month’s call-outs and this cycle’s bidding - names the facility’s administrators with their phone and email, and the Month card says what the month being built still needs, with a button that fixes each thing.',
          'At the top of Overview, anything about the facility itself that needs attention - no units listed, no staffing plan, a unit with no beds or never counted, a role the roster holds too few full-time equivalents of, credentials lapsing, no facility administrator - is listed in gold, or coral where it holds the month’s release, each with its button. With nothing to fix it says All clear.',
          'Recent activity lists what happened here since you last signed in. Tap a worker’s name to open their row on the Roster tab.',
          'Roster is the Worker Score Table: every worker with their tier, live score, call-outs, charting and bid status. The tab’s count is the notes from workers nobody has marked seen.',
          'Clinical Bridge shows shifts that need covering now, and who has answered. The tab’s count is the callouts still open.',
          'Partner rankings shows the most recent pools a partner asked this facility to rank.',
          'The tab you leave on is the one the dashboard opens on next time, in this browser.',
        ],
      },
      {
        heading: 'What you can do here',
        points: [
          'Add someone with New worker; give their email there and they are invited to the app at once. Open a row and its Details tab shows everything Edit worker holds and whether they were invited to the app and when they accepted; the other tabs hold their score breakdown, preferences and messages.',
          'Open a callout from the Clinical Bridge card when someone calls out, and choose who is held back.',
        ],
        seats: ['facility_administrator'],
      },
      {
        heading: 'What you can do here',
        points: [
          'Add someone with New worker; give their email there and they are invited to the app at once. Open a row and its Details tab shows everything Edit worker holds and whether they were invited to the app and when they accepted; the other tabs hold their score breakdown, preferences and messages.',
          'Callouts are opened by the facility’s administrator; you see them here as they happen.',
        ],
        seats: ['operator'],
      },
      {
        heading: 'Good to know',
        points: [
          'A tier only changes when a month closes. Mid-month the table shows where each worker is heading, “On track for …”.',
          'Scores update as shifts are reported. Recalculate scores on the Tools tab updates everyone at once.',
          'A blank call-out or charting figure means nothing is reported yet. It is not a zero.',
        ],
      },
    ],
    related: ['schedule.build-the-month'],
    learnMore: 'the Facility Manager and Operator guides in the training materials.',
  },
]
